const imageHeaders = {
	headers: { 'Content-Type': 'multipart/form-data' },
};

export default imageHeaders;
